import React from 'react';
import CheckInOut from '../components/CheckInOut';

const CheckInOutPage = ({ currentUser, selectedOrgId, checkInStatus, setCheckInStatus }) => (
  <div>
    <h2>Record Volunteer Time</h2>
    <CheckInOut
      userId={currentUser.id}
      orgId={selectedOrgId}
      initialStatus={checkInStatus}
      onStatusChange={setCheckInStatus}
    />
  </div>
);

export default CheckInOutPage;